import React from "react"
import PropTypes from "prop-types"
import Header from "../Header/index"
import Styles from "../SharedComponents"
import { Container } from "styled-container-component"

import "assets/styles/style.css"
import "assets/styles/bootstrap-grid.min.css"

import styled from "styled-components"

const Main = styled.main``
const Footer = styled.main`
  text-align: center;
`

const Layout = props => {
  const { children } = props
  return (
    <>
      <Header {...props} />
      <Main {...props}>{children}</Main>
      <Footer>
        <Container>
          <Styles.ColMargined>{new Date().getFullYear()}</Styles.ColMargined>
        </Container>
      </Footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
